/**
 * PHARMAKON — Trésorerie · « Ma caisse » read through the keyed treasury store (TWP-22; UX 02 §13).
 *
 * ONE store entry (`comptoir-moi`) shared by every reader of the caller's comptoir: the card of
 * `/caissier`, the head of « Mouvements de ma caisse » and the receiving toasts of the shell. It is
 * re-read only when a published key of HIS comptoir arrives (frame or this tab's write): once his
 * comptoir is known, its account, its legs and his session; before, the comptoir / session families
 * (a CAISSIER only receives the frames of his own comptoir — TA-75 (10)). Nothing is polled.
 * `actif` is the caller's right to read it (`tresorerie:create`, the counter roles).
 */
import { useStore } from "zustand";
import { tresoreriePharmacieApi } from "@/services/index.js";
import { cleRequete } from "@/lib/tresorerie/store.js";
import { dependancesMonComptoir } from "@/lib/tresorerie/caissier.js";
import { storeTresorerie, useTresorerieQuery } from "@/hooks/useTresorerieQuery.js";

export const RESSOURCE_MON_COMPTOIR = "comptoir-moi";
const CLE = cleRequete(RESSOURCE_MON_COMPTOIR, {});
const donnees = (r) => r?.data ?? r;

/** Re-read « Ma caisse » now (a session opened or closed by a gesture that publishes no treasury key). */
export const relireMonComptoir = () => storeTresorerie.charger(CLE);

/** @param {{ actif?: boolean }} [p] */
export function useMonComptoir({ actif = true } = {}) {
  const connu = useStore(storeTresorerie.store, (s) => s.entrees[CLE]?.data);
  return useTresorerieQuery({
    ressource: RESSOURCE_MON_COMPTOIR,
    depend: dependancesMonComptoir(connu),
    charger: () => tresoreriePharmacieApi.monComptoir().then(donnees),
    actif,
  });
}

export default useMonComptoir;
